interface TeamsFormData {
  league?: string;
  teams?: { slot1?: string; slot2?: string };
}

interface ResolutionInfo {
  canvasWidth: number;
  canvasHeight: number;
  aspectRatioCode?: string;
}

const formatSlug = (str: string) =>
  str
    .split('-')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join('');

// Convención ESPN: IS_TeamAVsTeamB_DVH_P80_1920x2400_es-419_V1.png
export const getFileNaming = (formData: TeamsFormData, resolution?: ResolutionInfo): string | undefined => {
  if (!resolution || !resolution.aspectRatioCode) return undefined;

  const { league, teams } = formData;
  const team1 = teams?.slot1;
  const team2 = teams?.slot2;

  if (!league || !team1 || !team2) return undefined;

  const prefix = `IS_${formatSlug(team1)}Vs${formatSlug(team2)}_DVH`;
  const { canvasWidth, canvasHeight, aspectRatioCode } = resolution;

  return `${prefix}_${aspectRatioCode}_${canvasWidth}x${canvasHeight}_es-419_V1.png`;
};
